import { render, staticRenderFns } from "./CBProposalStrongRoom.vue?vue&type=template&id=552564c5"
import script from "./CBProposalStrongRoom.vue?vue&type=script&lang=js"
export * from "./CBProposalStrongRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports